import type { Types } from '@fiverr-private/theme';

export const headerMenuProps: Types.ContainerProps = {
    as: 'span',
    display: 'inlineFlex',
    height: '24px',
    alignItems: 'center',
};
